<template>
	<main class="mypage sub_form">
		<article class="subscription_info">
			<div class="main_title">구독해지</div>
			<section class="subscription_info_details">
				<div class="c_fieldArea">
					<FieldLayout title="구독상품">
						<InputText
							:value="
								subscriptionDetail?.subscription_detail.pay_info_goods_name === ''
									? '구독권 지급'
									: subscriptionDetail?.subscription_detail.pay_info_goods_name
							"
							readonly
						/>
					</FieldLayout>
					<FieldLayout title="구독대가" class="column">
						<InputText
							v-for="(item, idx) in subscriptionDetail?.master_name"
							:key="idx"
							:value="item.master_name"
							readonly
						/>
					</FieldLayout>
					<FieldLayout title="이용기간">
						<InputText
							:value="`${subscriptionDetail?.subscription_detail.subscription_start_date?.split(' ')[0]}~${
								subscriptionDetail?.subscription_detail.subscription_end_date?.split(' ')[0]
							}`"
							readonly
						/>
					</FieldLayout>
					<FieldLayout title="다음 결제일">
						<InputText
							:value="
								subscriptionDetail?.subscription_detail.subscription_maintain_yn
									? dayjs(subscriptionDetail.subscription_detail.pay_info_next_pay_date).format('YYYY-MM-DD')
									: '정기 결제 해지된 상품'
							"
							readonly
						/>
					</FieldLayout>
					<FieldLayout title="결제 카드사">
						<InputText
							:value="`${subscriptionDetail?.subscription_detail.pay_info_card_company_name ?? '앱 결제'}`"
							readonly
						/>
					</FieldLayout>
					<FieldLayout title="결제금액">
						<InputText :value="`${subscriptionDetail?.subscription_detail.pay_info_goods_price}원`" readonly />
					</FieldLayout>
				</div>
				<div class="sub_text">
					<DangerIcon />
					<p>
						구독 해지 시 다음 정기 결제일부터 결제가 진행되지<br class="br_show" />
						않습니다.<br class="br_none" />
						구독을 해지 하시더라도 이미 결제한 회차의 잔여 이용기간까지 이용 가능합니다.
					</p>
				</div>
			</section>
			<div v-if="subscriptionDetail?.subscription_detail.subscription_maintain_yn" class="button_box">
				<button class="c_button primary-fill" @click="$router.go(-1)">구독 유지하기</button>
				<button
					class="c_button"
					@click="
						$router.push({
							path: `/sub/cancel-confirm/${route.params.subscription_pk}`,
							query: {
								date: subscriptionDetail?.subscription_detail.subscription_end_date?.split(' ')[0],
								currentTab: route.query.currentTab,
							},
						})
					"
				>
					구독 해지하기<img src="@/assets/img/common/arrow_next.svg" alt="구독해지하기 아이콘" loading="lazy" />
				</button>
			</div>
		</article>
	</main>
</template>

<script setup lang="ts">
// core
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
// lib
import dayjs from 'dayjs';

// api
import { useGetMemberSubscriptionDetailApi } from '@/api/mypage';
// img
import DangerIcon from '@/assets/img/common/danger.svg?component';
// component
import FieldLayout from '@/components/form/FieldLayout.vue';
// store
import { usePaymentStore } from '@/stores/payment';

// -----variable-----
const route = useRoute();
const paymentStore = usePaymentStore();

// -----api-----
const { data: subscriptionDetail, refetch: refetchSubscriptionDetail } = useGetMemberSubscriptionDetailApi(
	computed(() => {
		return {
			subscription_pk: Number(route.params.subscription_pk),
		};
	})
);

// -----composition-----
onMounted(async () => {
	await refetchSubscriptionDetail();
	if (subscriptionDetail.value) {
		paymentStore.setPayment(subscriptionDetail?.value.subscription_detail.pay_info_card_company_name ?? '앱 결제');
	}
});
</script>

<style lang="scss" scoped>
.sub_form {
	max-width: 68rem;
	padding-bottom: 8.8rem;
	@media screen and (max-width: 1280px) {
		padding-top: 4rem;
	}
	.subscription_info {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: var(--space-large);
		@media screen and (max-width: 1280px) {
			padding-bottom: 4rem;
		}
		.sub_text {
			margin-top: 2.4rem;
			display: flex;
			gap: 0.2rem;
			color: var(--color-danger);
			font-weight: var(--font-w-light);
			font-size: var(--font-s-mid);
			line-height: 1.9rem;
			svg {
				min-width: 2.2rem;
			}
		}
	}
	.button_box {
		display: flex;
		flex-direction: column;
		font-weight: var(--font-w-medium);
		font-size: var(--font-s-regular);
		line-height: 2.1rem;
		gap: 2rem;
		align-items: center;
		button:nth-child(1) {
			width: 100%;
			height: 4.8rem;
			font-weight: var(--font-w-medium);
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
		}
		button:nth-child(2) {
			height: 4.1rem;
			width: fit-content;
			font-weight: var(--font-w-medium);
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
			img {
				width: 1.8rem;
			}
		}
	}
}
.column :deep(.field) {
	flex-direction: column;
}
</style>
